// Render Prop

import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import SimpleField from "../../forms/SimpleField";
import { SelectField } from "../../forms/SelectField";
import Supervisor from '../../../store/wrappers/Supervisor';

import BackButton from "../../widgets/BackButton";



export class SupervisorForm extends Component {
    static displayName = SupervisorForm.name;

    constructor(props) {
        super(props);

        //Assume we're creating a new supervisor unless the user provided a valid id as a url argument
        let supervisor = false;
        let displayMode = "new"
        if (this.props.match.params.id) {
            supervisor = this.props.store.supervisors.getById(this.props.match.params.id);
            displayMode = "edit"
        }


        this.state = {
            loading: true,
            supervisor: supervisor,
            mode: displayMode
        };

        if (displayMode == "new") {
            this.props.store.updateBanner("Add New");
        }
        else {
            this.props.store.updateBanner("Update Supervisor", supervisor.name);
        }

    }


    /*componentDidMount() {
        //If the id parameter in the URL is set
        if (this.props.match.params.id) {
            const supervisor = this.props.store.supervisors.getById(this.props.match.params.id);
            this.setState({ supervisor: supervisor });
        }
    }

    //Rerender if we're going from edit to new state
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.mode !== this.props.mode && !this.props.match.params.id) {
            this.setState({ supervisor: null });
        }
    }*/


    setInitialValues() {
        let supervisor = this.state.supervisor;
        if (!supervisor) {
            supervisor = new Supervisor()
        }

        return {
            id: supervisor.id || "",
            email: supervisor.email || "",
            designation: supervisor.designation || "",
            name: supervisor.name || "",
            employerId: supervisor.employerId || "0"
        }
    }

    async handleSubmission(values, setSubmitting, resetForm) {
        this.setState({ setSubmitting: true });

        //If the user creates a new employer, the form doesn't get rerendered. That would be easy!

        if (values.id == "" && this.state.supervisor.id) {
            values.id = this.state.supervisor.id; 
        }


        let supervisor = new Supervisor(values, true);

        supervisor = await supervisor.save(this.props.store);

        console.log(supervisor);

        if (this.state.mode == "new" && (supervisor.errors == null || supervisor.errors.length == 0)) {
            console.log("added new supervisor!")

            resetForm()
            this.setState({ setSubmitting: false });
        }
        else if (this.state.mode == "edit" && (supervisor.errors == null || supervisor.errors.length == 0)) {
            console.log("updated employer state")
            this.setState({
                supervisor: supervisor,
                setSubmitting: false,
                mode: "edit"
            });
        }
    }

    validate(values) {
        const errors = {};
        if (!values.email) {
            errors.email = 'Required';
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
            errors.email = 'Invalid email address';
        }

        if (values.employerId == "0") {
            errors.employerId = "Must select an employer"
        }

        return errors;
    }

    render() {
        return (
            <div>
                {this.introText()}
                <div className="row">
                    <div className="col-12 col-md-6">
                        {this.form()}
                    </div>
                </div>
            </div>
        )
    }

    introText() {
        if (this.state.mode == "new") {
            return (
                <React.Fragment>
                    <h1 className="h3">New Supervisor</h1>
                </React.Fragment>
            )
        }
        return (undefined)
    }
    

    form() {
        let employers = this.props.store.employers.collection;

        employers.sort((employerA, employerB) => {
            if(employerA.name > employerB.name) {
                return 1;
            }
            else if(employerB.name > employerA.name) {
                return -1;
            }
            return 0;
        });

        return (
            (this.state.mode == "new" || this.state.supervisor ? (
                <Formik
                    initialValues={this.setInitialValues()}
                    validate={values => this.validate(values)}
                    onSubmit={(values, { setSubmitting, resetForm }) => this.handleSubmission(values, setSubmitting, resetForm)}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Field name="id" className="form-control" type="hidden" />

                            <SelectField items={employers} name="employerId" label="Employer" />

                            <SimpleField name="name" />

                            <SimpleField name="designation" label="Designation (optional)" />

                            <SimpleField name="email" type="email" />

                            <div className="staffFormSubmitButtons">
                                {this.state.mode !== "new" &&
                                    <BackButton className="btn btn-secondary mt-2 mr-2" innerText="Cancel" />
                                }
                                <button className="btn btn-primary mt-2" type="submit" disabled={isSubmitting}>
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            ) :
            (
                <div>
                    <h3>Could not find supervisor</h3>
                </div>
            )
            )
        );
    }
}
